import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import DailyLog from "@/pages/DailyLog";
import History from "@/pages/History";
import ContextPlan from "@/pages/ContextPlan";
import Reports from "@/pages/Reports";
import TeamReports from "@/pages/TeamReports";
import OrgAdmin from "@/pages/OrgAdmin";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import Dashboard from "@/pages/Dashboard";
import Help from "@/pages/Help";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SharedReport from "@/pages/SharedReport";
import Legal from "@/pages/Legal";
import EnvBanner from "@/components/EnvBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/shared/:shareId" element={<SharedReport />} />
            <Route path="/terms" element={<Legal doc="terms" />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/ai-use" element={<Legal doc="ai-use" />} />
            <Route path="/cookies" element={<Legal doc="cookies" />} />
            <Route path="/:lang/terms" element={<Legal doc="terms" />} />
            <Route path="/:lang/privacy" element={<Legal doc="privacy" />} />
            <Route path="/:lang/ai-use" element={<Legal doc="ai-use" />} />
            <Route path="/:lang/cookies" element={<Legal doc="cookies" />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/app" element={<Layout />}>
              <Route index element={<Navigate to="/app/log" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="log" element={<DailyLog />} />
              <Route path="history" element={<History />} />
              <Route path="context" element={<ContextPlan />} />
              <Route path="reports" element={<Reports />} />
              <Route path="team" element={<TeamReports />} />
              <Route path="access" element={<Navigate to="/app/reports" replace />} />
              <Route path="organization" element={<OrgAdmin />} />
              <Route path="billing" element={<Billing />} />
              <Route path="help" element={<Help />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <EnvBanner />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
